import React from 'react';
import styled from 'styled-components';
import { breakpoints, Container, gridCss } from '../../styles/layout';
import Img from 'gatsby-image';
import { typeN14r, typeN21r, typeT21sb, typeT38sb } from '../../styles/typography/presets';
import { colors } from '../../styles/colors';
import TextCombo from '../shared/TextCombo';
import { DarkBlueOutlineButton, DarkBlueOutlineButtonLink } from '../buttons';
import routes from '../../routes';
import Rellax from 'rellax';
import FluidImg from '../shared/FluidImg';
import GradientBlocks from '../shared/GradientBlocks';


const Title = styled.div`
  ${typeT21sb};
`;

const Message = styled.div`
  ${typeN14r};
`;

const InitiativeText = styled(TextCombo)`
  max-width: 362px;
`;

const InitiativeImage = styled.div`
  border-radius: 6px;
  overflow: hidden;
`;

const Initiative = styled(Container)`

`;

const Quote = styled.span`

`;

const QuoteContainer = styled.aside`
  ${typeT21sb};
  ${gridCss};
  margin-bottom: 40px;
  ${Quote} {
    grid-column: 2 / span 8;
  }
`;

const Initiatives = styled.div`
  padding-top: 60px;
  ${Initiative} {
    padding-bottom: 60px;

    ${InitiativeText} {
      margin-bottom: 60px;
      grid-column: 2 / span 8;
      z-index: 1;
    }

    ${InitiativeImage} {
      grid-column: 2 / span 8;
      z-index: 1;
    }

    &:nth-of-type(6n+2),
    &:nth-of-type(6n+4) {
      grid-template-rows: 30px auto auto 50px;
      &:before {
        content: '';
        z-index: 0;
        background: ${colors.orangishGrey};
        grid-row: 1 / span 3;
        grid-column: 1 / span 10;
      }
      ${InitiativeText} {
        z-index: 1;
        grid-row: 2;
      }
      ${InitiativeImage} {
        z-index: 1;
        grid-row: 3 / span 2;
      }
    }

    &:nth-of-type(6n+4) {
      grid-template-rows: 30px auto auto 200px;
    }
  }

  @media(max-width: ${breakpoints.lg}) {
    .rellax {
      transform: translate3d(0,0,0) !important;
    }
  }

  @media(min-width: ${breakpoints.lg}) {
    padding-bottom: 160px;
    display: flex;
    flex-direction: column;

    ${QuoteContainer} {
      ${typeT38sb};
      ${Quote} {
        grid-column: 2 / span 6;
        max-width: 854px;
      }
    }

    ${Initiative} {
      ${InitiativeImage} {
        max-height: 600px;
      }

      &:nth-of-type(6n+1) {
        padding: 0 0 90px;
        justify-content: flex-start;
        align-items: flex-start;
        ${InitiativeText} {
          grid-column: 2 / span 4;
        }
        ${InitiativeImage} {
          grid-column: 6 / span 4;
          padding-right: 110px;
        }
      }
      &:nth-of-type(6n+2) {
        grid-template-rows: 90px auto 200px 60px;
        justify-content: flex-end;
        &:before {
          content: '';
          background: ${colors.orangishGrey};
          grid-column: 1 / span 10;
          grid-row: 1 / span 2;
        }
        ${InitiativeText} {
          grid-column: 2 / span 4;
          margin-bottom: 110px;
          grid-row: 2;
        }
        ${InitiativeImage} {
          grid-column: 6 / span 5;
          grid-row: 2 / span 2;
          .gatsby-image-wrapper {
            height: 100%;
          }
        }
      }
      &:nth-of-type(6n+3) {
        grid-template-rows: auto 165px;
        ${InitiativeText} {
          grid-column: 4 / span 4;
          grid-row: 1;
          margin-left: 6vw;
          margin-bottom: 120px;
        }
        ${InitiativeImage} {
          grid-column: 1 / span 3;
          grid-row: 1 / span 2;
          margin-left: 8vw;
        }
      }
      &:nth-of-type(6n+4) {
        grid-template-rows: 110px auto 142px;
        margin-top: -165px;
        &:before {
          content: '';
          background: ${colors.orangishGrey};
          grid-column: 1 / span 10;
          grid-row: 1 / span 2;
        }
        ${InitiativeText} {
          grid-row: 2 / span 1;
          grid-column: 4 / span 4;
          margin-left: 6vw;
          margin-bottom: 112px;
        }
        ${InitiativeImage} {
          grid-row: 2 / span 2;
          grid-column: 8 / span 3;
          margin-right: 8vw;
        }
      }
      &:nth-of-type(6n+5) {
        padding: 60px 0;
        ${InitiativeText} {
          grid-column: 2 / span 4;
        }
        ${InitiativeImage} {
          grid-column: 6 / span 4;
        }
      }
      &:nth-of-type(6n+6) {
        padding: 60px 0;

        ${InitiativeText} {
          grid-column: 6 / span 4;
          grid-row: 1;
          justify-self: flex-end;
        }

        ${InitiativeImage} {
          grid-row: 1;
          grid-column: 2 / span 4;
        }
      }

    }
  }
`;

const CustomGradientBlocks = styled(GradientBlocks)``;

const CustomContainer = styled(Container)`
  padding: 30px 0;
  ${Title} {
    grid-column: 2 / span 8;
  }

  ${Message} {
    grid-column: 2 / span 8;
  }

  ${CustomGradientBlocks},
  ${Initiatives} {
    grid-column: 1 / span 10;
  }

  @media(min-width: ${breakpoints.lg}) {
    ${Title} {
      ${typeT38sb};
      grid-column: 2 / span 4;
      margin-bottom: 12px;
    }
    ${Message} {
      ${typeN21r};
      grid-column: 2 / span 4;
      margin-bottom: 30px;
    }
  }
`;

class InitiativesSection extends React.Component {
  render() {
    const { pageData, ...props } = this.props;
    return (
      <CustomContainer {...props}>
        {/*<Title>{pageData.initiatives_title}</Title>*/}
        {/*<Message>{pageData.initiatives_message}</Message>*/}
        <CustomGradientBlocks
          blocks={pageData.initiatives.filter(initiative => initiative.service_page).map((initiative, index) => ({
            title: (index + 1).toString().padStart(2, '0'),
            message: initiative.title,
            brief: initiative.brief.html,
            image: initiative.image,
            buttonText: 'Learn more',
            buttonLink: `${routes.initiatives}/${initiative.service_page.uid}`,
          }))}
        />
      </CustomContainer>
    );
  }
}


export default InitiativesSection;
